export default __webpack_public_path__ + "static/media/ubuntu-regular.118f30b4.eot";